import { Nav } from "../nav/Nav";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import "./Header.css";
import AOS from "aos";
import "aos/dist/aos.css";

export const Header = ({ headerName, bgImage }) => {
  const location = useLocation();

  useEffect(() => {
    AOS.init({ duration: 1000, once: false });
  }, []);

  useEffect(() => {
    AOS.refreshHard(); 
  }, [location.pathname]);

  return (
    <div
      className="header"
      style={{ backgroundImage: `url(${bgImage})` }}
      key={location.pathname}
    >
      <div>
        <Nav />
      </div>
      <div className="header-content">
        <h1
          className="header-title"
          data-aos="fade-down"
          data-aos-duration="1000"
          data-aos-easing="ease-in-out"
        >
          {headerName}
        </h1>
        <h1
          data-aos="fade-up"
          data-aos-delay="300"
          data-aos-duration="1000"
          data-aos-easing="ease-in-out"
        >
          Adhie Annan Temple
        </h1>
      </div>
    </div>
  );
};
